import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';

import { sortTableDateFechaInicio, sortTableDateFechaFin, sortTableStatusStatus } from '../../utils/generalFunctions';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { buscarCitas, obtenerCita, filtarCitas } from '../../actions/citas';

import FiltrosCitas from './FiltrosCitas';
import NuevaCita from './NuevaCita';
import DetallesCita from './DetallesCita';
import EditarCita from './EditarCita';
import EliminarCita from './EliminarCita';

const Citas = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Citas',
            path: '/citas'
        }
    ];

    const dispatch = useDispatch();

    const { listado } = useSelector(state => state.citas);

    const [citas, setCitas] = useState([]);
    const [citaAgregar, setCitaAgregar] = useState(null);
    const [citaDetalles, setCitaDetalles] = useState(null);
    const [citaEditar, setCitaEditar] = useState(null);
    const [citaEliminar, setCitaEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Razón o responsable',
            sortable: true,
            wrap: true,
            selector: row => row.titulo,
            grow: 2
        },
        {
            name: 'Locatario',
            sortable: true,
            wrap: true,
            selector: row => row.locatario ? row.locatario.nombre : 'Sin definir'
        },
        {
            name: 'Fecha de inicio',
            sortable: true,
            sortFunction: sortTableDateFechaInicio,
            cell: item => new Date(item.fecha_inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' a las ' + new Date(item.fecha_inicio).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
            grow: 2
        },
        {
            name: 'Fecha de finalización',
            sortable: true,
            sortFunction: sortTableDateFechaFin,
            cell: item => new Date(item.fecha_fin).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' a las ' + new Date(item.fecha_fin).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
            grow: 2
        },
        {
            name: 'Status',
            sortable: true,
            sortFunction: sortTableStatusStatus,
            cell: row => {
                switch(row.status){
                    case 0:
                        return <h5><Badge pill bg="warning" className="text-dark">Agendada</Badge></h5>;
                    case 1:
                        return <h5><Badge pill bg="success">Finalizada</Badge></h5>;
                    case 2:
                        return <h5><Badge pill bg="danger">Cancelada</Badge></h5>;
                    default:
                        return <h5><Badge pill bg="secondary">No aplica</Badge></h5>;
                }
            }
        },
        {
            name: 'Pago',
            sortable: true,
            cell: row => {
                switch(row.pagada){
                    case true:
                        return <h5><Badge pill bg="success">Pagada</Badge></h5>;
                    case false:
                        return <h5><Badge pill bg="danger">Pendiente</Badge></h5>;
                    default:
                        return <h5><Badge pill bg="secondary">No aplica</Badge></h5>;
                }
            }
        },
        {
            name: '',
            cell: row => (
                <div className="text-right w-100">
                    <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleDetallesCita({ id: row.id })}><i className="fas fa-eye fa-sm text-info"></i></button>
                </div>
            ),
            grow: 0.5
        }
    ];

    /* Filtros */
    const handleFiltrosBusqueda = () => {
        dispatch(filtarCitas(true));
    }

    /* Crear cita */
    const handleAgregarCita = (cita) => {
        setCitaDetalles(null);
        setCitaEditar(null);
        setCitaEliminar(null);
        setCitaAgregar(cita);
    }

    /* Detalles cita */
    const handleDetallesCita = (cita) => {
        setCitaAgregar(null);
        setCitaEditar(null);
        setCitaEliminar(null);
        setCitaDetalles(cita);
    }

    /* Editar cita */
    const handleEditarCita = (cita) => {
        setCitaAgregar(null);
        setCitaDetalles(null);
        setCitaEliminar(null);
        setCitaEditar(cita);
    }

    /* Eliminar cita */
    const handleEliminarCita = (cita) => {
        setCitaAgregar(null);
        setCitaDetalles(null);
        setCitaEditar(null);
        setCitaEliminar(cita);
    }

    useEffect(() => {
        dispatch(buscarCitas({
            status: null,
            pagada: null,
            fecha_inicio: null,
            fecha_fin: null
        }));

        return () => {
            dispatch(obtenerCita(null));
        }
    }, []);

    useEffect(() => {
        let listado_eventos = [];

        for(var i = 0; i < listado?.length; i++) {
            listado_eventos.push({
                id: listado[i]?._id,
                fecha_inicio: listado[i]?.fecha_inicio,
                fecha_fin: listado[i]?.fecha_fin,
                titulo: listado[i]?.titulo,
                locatario: listado[i]?.locatario,
                status: listado[i]?.status,
                pagada: listado[i]?.pagada
            });
        }

        setCitas(listado_eventos);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <FiltrosCitas />

            <NuevaCita cita={citaAgregar} reestablecerCita={handleAgregarCita} />
            <DetallesCita cita={citaDetalles} reestablecerCita={handleDetallesCita} editarCita={handleEditarCita} eliminarCita={handleEliminarCita} />
            <EditarCita cita={citaEditar} reestablecerCita={handleEditarCita} />
            <EliminarCita cita={citaEliminar} reestablecerCita={handleEliminarCita} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Citas</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary me-2" onClick={() => handleFiltrosBusqueda()}>Filtros de búsqueda</button>
                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarCita({})}>Agregar cita</button>
                    </div>

                    <div className="mt-4">
                        <DataTable
                            columns={columns}
                            data={citas}
                            noDataComponent="No hay citas registradas"
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Citas;
